var map = {
	"./Pricing-cofi.vue": [
		"47be",
		"chunk-0c470708",
		"chunk-17f40d38"
	],
	"./Pricing.vue": [
		"dc78",
		"chunk-41d53576"
	],
	"./Pricing2024.vue": [
		"fcd8",
		"chunk-0c470708",
		"chunk-3805daed"
	],
	"./PricingSupportPlans.vue": [
		"a767",
		"chunk-0c470708",
		"chunk-6444e5b4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7d34";
module.exports = webpackAsyncContext;